'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRACKER_NAME = undefined;
exports.init = init;
exports.getTrackerData = getTrackerData;

var _trackAttribution = require('./trackAttribution');

var _trackAttribution2 = _interopRequireDefault(_trackAttribution);

var _storage = require('./storage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global window */

var DEFAULT_OPTIONS = {
  storageName: 'lm_tracker',
  overrideAttribution: false
};

var TRACKER_NAME = exports.TRACKER_NAME = 'lm_tracker_ref';

function init() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _DEFAULT_OPTIONS$opti = Object.assign({}, DEFAULT_OPTIONS, options),
      storageName = _DEFAULT_OPTIONS$opti.storageName,
      overrideAttribution = _DEFAULT_OPTIONS$opti.overrideAttribution;

  (0, _trackAttribution2.default)({
    overrideAttribution: overrideAttribution,
    storageName: storageName + '_ref'
  });
}

function getTrackerData() {
  if (typeof window !== 'undefined') {
    return (0, _storage.getSessionData)(TRACKER_NAME);
  }
  return {};
}

var tracker = { init: init, getTrackerData: getTrackerData };
exports.default = tracker;

if (typeof window !== 'undefined') {
  window.lmtracker = tracker;
}